import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['minInput', 'maxInput', 'errorMessage']

  declare minInputTarget: HTMLInputElement
  declare maxInputTarget: HTMLInputElement
  declare errorMessageTarget: HTMLElement

  private checkMinMaxError(minValue: number, maxValue: number): void {
    if (minValue > maxValue) {
      this.errorMessageTarget.textContent = "Min exceeds Max.";
    } else {
      this.errorMessageTarget.textContent = "";
    }
  }

  public validateMinMax(): void {
    const minValue = parseInt(this.minInputTarget.value);
    const maxValue = parseInt(this.maxInputTarget.value);

    this.checkMinMaxError(minValue, maxValue);
  }

  public resetAnswerLimit(event: Event): void {
    const dataId = (event.currentTarget as HTMLElement).dataset.id;
    const allowWriteIns = document.querySelector(`#question_${dataId}_question_allow_writeins`);
    const answerLimit = document.querySelector(`#question_${dataId}_question_answer_limit`);

    if (!allowWriteIns.checked) {
      answerLimit.value = 1
    }
  }
}
